import React from 'react';

import { StyleSheet, View } from 'react-native';

import { A11yWrapper } from 'components/a11y-wrapper';
import Currency from 'components/currency';
import { Typography } from 'components/ui';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

interface BagFeeRowProps {
  bagFeeCents: number;
  enablePosOrderSurchargesAsFees: boolean;
  isLoading?: boolean;
}

export const BagFeeRow: React.FC<BagFeeRowProps> = ({
  bagFeeCents,
  enablePosOrderSurchargesAsFees,
  isLoading,
}) => {
  if (!enablePosOrderSurchargesAsFees || bagFeeCents <= 0) {
    return null;
  }

  if (isLoading) {
    return <CurrencyLineSkeleton />;
  }

  return (
    <View style={styles.row}>
      <A11yWrapper>
        <Typography
          color={getDesignToken('text-default')}
          fontSize="md"
          style={styles.label}
          testID="bag-fee-name"
        >
          {t('bagFee', 'Bag Fee')}
        </Typography>
      </A11yWrapper>
      <View focusable testID="bag-fee-amount">
        <Currency amount={bagFeeCents} textProps={{ fontSize: 'md' }} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  label: {
    flexGrow: 1,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
  },
});
